/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react'
import * as Yup from 'yup'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Utils
import { getCustomerStatus } from 'common/utils/customerValidation'

// Store
import { actions } from 'core/store'

// Constants
import { ROLE_OPTIONS } from 'common/constants/formOptions'

// Hooks
import { useRequestEmailVerification } from 'core/hooks/api'
import { useLocalStorage } from 'core/hooks/storage'

// Styled Elements
import { FormWrapper, FormInputGroupItem, FormGroupWrapper } from './UserDetailsForm.elements'

// Views
import { Form, FormTextField, FormSelect, Button } from 'views/components'

// Map Redux Props
const mapStateToProps = (state) => state
const mapDispatchToProps = actions

function UserDetailsForm(props) {
  // Destructure
  const { values, viewMode, formRef, actions } = props
  const { showAlert } = actions

  // Hooks
  const {
    requestEmailVerification,
    isRequestEmailVerificationLoading,
    isRequestEmailVerificationSuccess,
    isRequestEmailVerificationError,
  } = useRequestEmailVerification()
  const [currentUser] = useLocalStorage('userCredentials', {})

  // Internal State
  const [initialData, setInitialData] = useState()
  const [csi] = useState(getCustomerStatus())

  // Variables
  const validationSchema = Yup.object().shape({
    name_first: Yup.string(),
    name_last: Yup.string(),
    email: Yup.string().email(),
    phone: Yup.string(),

    role: Yup.string(),
    timezone: Yup.string(),
    role_id: Yup.number().nullable(),
    is_active: Yup.boolean(),
    is_verified: Yup.boolean(),
  })

  // UseEffects
  useEffect(() => {
    setInitialData(values)
  }, [values])
  useEffect(() => {
    if (!isRequestEmailVerificationLoading) {
      if (isRequestEmailVerificationSuccess) {
        showAlert({ type: 'success', message: 'A link was sent to your email' })
      } else if (isRequestEmailVerificationError) {
        showAlert({ type: 'error', message: 'An error occurred, please try again later.' })
      }
    }
  }, [isRequestEmailVerificationSuccess, isRequestEmailVerificationError])
  return (
    <FormWrapper>
      {initialData && (
        <Form formRef={formRef} initialValues={initialData} validationSchema={validationSchema}>
          <FormGroupWrapper>
            <FormInputGroupItem>
              <FormTextField disabled={viewMode} label="First Name" name="name_first" />
            </FormInputGroupItem>
            <FormInputGroupItem>
              <FormTextField disabled={viewMode} label="Last Name" name="name_last" />
            </FormInputGroupItem>
            <FormInputGroupItem>
              <FormSelect
                disabled={viewMode || currentUser?.role_id !== 1}
                label="User Role"
                options={ROLE_OPTIONS}
                name="role_id"
              />
            </FormInputGroupItem>
            <FormInputGroupItem>
              <FormTextField
                disabled={viewMode || csi !== 1}
                label={initialData?.is_verified ? 'Email (Verified)' : 'Email (Unverified)'}
                type="email"
                name="email"
              />
              {!initialData?.is_verified &&
                <Button
                  onClick={() => requestEmailVerification()}
                  disabled={isRequestEmailVerificationLoading}
                >{isRequestEmailVerificationLoading ? 'Loading...' : 'Verify'}
                </Button>
              }
            </FormInputGroupItem>
            <FormInputGroupItem>
              <FormTextField disabled={viewMode} label="Phone Number" type="tel" name="phone" />
            </FormInputGroupItem>
            {/* NOTE: Add timezone_description input if needed */}
            {/* <FormInputGroupItem>
              <FormTextField disabled={viewMode} label="Timezone" name="timezone_code" />
            </FormInputGroupItem> */}
          </FormGroupWrapper>
        </Form>
      )}
    </FormWrapper>
  )
}

// Default Props
UserDetailsForm.defaultProps = {
  formRef: {},
  form: {},
  actions: {},
  values: {},
  viewMode: true,
}

// Proptypes Validation
UserDetailsForm.propTypes = {
  formRef: PropTypes.shape({ root: PropTypes.string }),
  form: PropTypes.shape({
    COUNTRIES_LIST: PropTypes.instanceOf(Array),
    toBeUpdatedAccount: PropTypes.func,
  }),
  actions: PropTypes.shape({
    setCountryListOptions: PropTypes.func,
    setIsEntityAccountDrawerOpen: PropTypes.func,
    setToBeUpdatedAccount: PropTypes.func,
    setIsPageTableUpdated: PropTypes.func,
    showAlert: PropTypes.func,
  }),
  values: PropTypes.shape({
    name_first: PropTypes.string,
    name_last: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    role: PropTypes.string,
    timezone: PropTypes.string,
    is_active: PropTypes.bool,
    is_verified: PropTypes.bool,
  }),
  viewMode: PropTypes.bool,
}

export default connect(mapStateToProps, mapDispatchToProps)(UserDetailsForm)
